(function () {
  if (window.__mvSw) return;
  window.__mvSw = 1;
  var MAP = [['dark brown','#4a2e1d'],['light brown','#a9835a'],['dark gr','#555555'],['light gr','#c9c9c9'],['dark blue','#1f3a68'],['light blue','#a9c8e8'],['sky blue','#8fc3e8'],['dark green','#1f4a2e'],['light green','#a8d5a0'],['army green','#4b5320'],['black','#111111'],['white','#ffffff'],['ivory','#f5f1e6'],['cream','#f3ead2'],['beige','#d9c7a3'],['sand','#d8c8a8'],['khaki','#b5a373'],['camel','#b98a52'],['tan','#c19a6b'],['taupe','#a39182'],['mocha','#7a5a45'],['coffee','#6f4e37'],['chocolate','#4a2c1d'],['brown','#7b4a2b'],['charcoal','#3b3b3b'],['gray','#888888'],['grey','#888888'],['navy','#1f2a4a'],['blue','#2e5fa8'],['teal','#2a8a8a'],['mint','#a8dcc2'],['olive','#6b6b2e'],['green','#3a7d44'],['burgundy','#6d1a2b'],['wine','#6d1a2b'],['red','#c62828'],['pink','#f4a6b8'],['rose','#e58fa0'],['purple','#6b3fa0'],['violet','#7e57c2'],['orange','#ef7d22'],['apricot','#f5b38a'],['yellow','#f2d230'],['gold','#c9a227'],['silver','#c0c0c0'],['camo','#6b705c']];
  function hex(n) { n = String(n).toLowerCase(); for (var i = 0; i < MAP.length; i++) { if (n.indexOf(MAP[i][0]) > -1) return MAP[i][1]; } return null; }
  var st = document.createElement('style');
  st.textContent = '.mv-sw{display:flex;gap:.6rem;align-items:center;flex-wrap:wrap;margin:.8rem 0 .2rem}.mv-sw a{display:block;width:1.3rem;height:1.3rem;border-radius:50%;border:1px solid rgba(0,0,0,.2);background-size:cover;background-position:center}.mv-sw__more{font-size:1.1rem;opacity:.7}.mv-pdp-sw label{width:6.4rem!important;height:6.4rem!important;padding:0!important;font-size:0!important;line-height:0!important;color:transparent!important;background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important;border-radius:0}.mv-pdp-sw input:checked+label{background-color:transparent!important;outline:2px solid #2a1d15;outline-offset:1px}.mv-pdp-sw{gap:.8rem!important}.mv-cn{margin-left:.8rem;opacity:.75}.mv-drawer-notes{display:none!important}.mv-ct{display:flex;justify-content:space-between;gap:.8rem;margin:1.4rem 0 .4rem;text-align:center}.mv-ct__i{flex:1;font-size:1.1rem;letter-spacing:.04em;line-height:1.3}.mv-ct__i svg{display:block;width:2.4rem;height:2.4rem;margin:0 auto .5rem;fill:none;stroke:currentColor;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round}.mv-sav{display:flex;justify-content:space-between;align-items:center;gap:1rem;margin:0 0 1rem;padding:1rem 0;border-top:1px solid rgba(58,40,29,.14);color:#1e7b3a;font-size:1.5rem;font-weight:600}.mv-sav__l{display:flex;align-items:center;gap:.8rem}.mv-sav__l::before{content:"";width:1.8rem;height:1.8rem;background:url(data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2024%2024%27%20fill=%27none%27%20stroke=%27%231e7b3a%27%20stroke-width=%271.6%27%3E%3Cpath%20d=%27M3.5%2012.5V4.5h8l9%209-8%208z%27/%3E%3Ccircle%20cx=%278%27%20cy=%279%27%20r=%271.3%27/%3E%3C/svg%3E) no-repeat center/contain}.mv-old{display:inline-block;margin-right:.6rem;opacity:.65;text-decoration:line-through}.cart-item__price-wrapper .mv-old{display:block;margin:0}';
  document.head.appendChild(st);
  var data = null, loading = null;
  function load() {
    if (data) return Promise.resolve(data);
    if (!loading) loading = fetch('/collections/all/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { var m = {}; (j.products || []).forEach(function (p) { m[p.handle] = p; }); data = m; return m; }).catch(function () { data = {}; return data; });
    return loading;
  }
  function colourOption(p) { var o = null; (p.options || []).forEach(function (x) { if (!o && /colou?r/i.test(x.name)) o = x; }); return o; }
  function build(p) {
    var op = colourOption(p);
    if (!op || op.values.length < 2) return null;
    var el = document.createElement('div');
    el.className = 'mv-sw';
    var shown = 0;
    op.values.forEach(function (val) {
      if (shown >= 6) return;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i]['option' + op.position] === val) { v = p.variants[i]; break; } }
      var a = document.createElement('a');
      a.href = '/products/' + p.handle + (v ? '?variant=' + v.id : '');
      a.title = val;
      a.setAttribute('aria-label', val);
      var h = hex(val);
      if (h) { a.style.background = h; }
      else if (v && v.featured_image && v.featured_image.src) { a.style.backgroundImage = 'url(' + v.featured_image.src + ')'; }
      else { a.style.background = '#cccccc'; }
      el.appendChild(a);
      shown++;
    });
    if (op.values.length > 6) { var m = document.createElement('span'); m.className = 'mv-sw__more'; m.textContent = '+' + (op.values.length - 6); el.appendChild(m); }
    return el;
  }
  function decorate() {
    var cards = [].slice.call(document.querySelectorAll('.card-wrapper:not([data-mv-sw])'));
    if (!cards.length) return;
    cards.forEach(function (c) { c.setAttribute('data-mv-sw', '1'); });
    load().then(function (map) {
      cards.forEach(function (c) {
        if (c.querySelector('.mv-sw')) return;
        var a = c.querySelector('a.full-unstyled-link');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        var parts = href.split('/products/');
        if (parts.length < 2) return;
        var p = map[parts[1].split(/[?#]/)[0]];
        if (!p) return;
        var el = build(p);
        if (!el) return;
        var anchor = null;
        c.querySelectorAll('.card__information').forEach(function (x) { if (!x.closest('.card__inner')) anchor = x; });
        if (anchor) anchor.insertAdjacentElement('beforebegin', el);
      });
    });
  }
  /* productpagina: kleurkeuze met foto's */
  var pdpP = null;
  function pdp() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var fs = null;
    info.querySelectorAll('fieldset.product-form__input').forEach(function (f) { var lg = f.querySelector('legend'); if (!fs && lg && /colou?r/i.test(lg.textContent)) fs = f; });
    if (!fs || fs.getAttribute('data-mv-pdp')) return;
    fs.setAttribute('data-mv-pdp', '1');
    var h = location.pathname.split('/products/')[1];
    if (!h) return;
    h = h.split(/[?#\/]/)[0];
    if (!pdpP) pdpP = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    pdpP.then(function (p) {
      if (!p) return;
      var pos = -1;
      p.options.forEach(function (o, i) { if (/colou?r/i.test(o.name)) pos = i; });
      if (pos < 0) return;
      var any = false;
      fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].options[pos] === inp.value) { v = p.variants[i]; break; } }
        var src = v && v.featured_image && v.featured_image.src;
        var lab = inp.nextElementSibling;
        if (src && lab) { lab.style.backgroundImage = 'url(' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160)'; any = true; }
      });
      if (any) { fs.classList.add('mv-pdp-sw'); }
      var lg = fs.querySelector('legend');
      if (lg) {
        var sp = lg.querySelector('.mv-cn');
        if (!sp) { sp = document.createElement('span'); sp.className = 'mv-cn'; lg.appendChild(sp); }
        var upd = function () { var ch = fs.querySelector('input:checked'); sp.textContent = ch ? '- ' + ch.value : ''; };
        upd();
        fs.addEventListener('change', upd);
      }
    });
  }
  /* mandje en mandlade: vertrouwensicoontjes onder de checkoutknop */
  var CT = [
    { p: `<path d='M2 8h11v8H2z'/><path d='M13 11h4l4 3v2h-8z'/><circle cx='6.5' cy='18.5' r='1.5'/><circle cx='17.5' cy='18.5' r='1.5'/>`, t: 'Free UK shipping' },
    { p: `<rect x='5' y='11' width='14' height='9' rx='1'/><path d='M8 11V8a4 4 0 0 1 8 0v3'/><circle cx='12' cy='15.5' r='1'/>`, t: 'Secure checkout' },
    { p: `<path d='M3 12a9 9 0 1 1 3 6.7'/><path d='M3 17v-5h5'/>`, t: '30-day returns' }
  ];
  function cartTrust() {
    document.querySelectorAll('button[name=checkout]').forEach(function (b) {
      var host = b.closest('.cart__ctas') || b.parentElement;
      if (!host || !host.parentElement) return;
      if (host.parentElement.querySelector('.mv-ct')) return;
      var el = document.createElement('div');
      el.className = 'mv-ct';
      el.innerHTML = CT.map(function (i) { return `<div class='mv-ct__i'><svg viewBox='0 0 24 24' aria-hidden='true'>${i.p}</svg><span>${i.t}</span></div>`; }).join('');
      host.insertAdjacentElement('afterend', el);
    });
  }
  /* mandje en mandlade: echte besparing tonen (doorgestreepte oorspronkelijke prijs + totaal bespaard) */
  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function setOld(el, txt) { if (el.textContent.trim() !== txt) el.textContent = txt; }
  function cartSavings() {
    var foots = document.querySelectorAll('.totals');
    if (!foots.length) return;
    Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), load()]).then(function (res) {
      var cart = res[0], map = res[1], sav = 0;
      cart.items.forEach(function (i, idx) {
        var p = map[i.handle], v = null;
        if (p) { for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].id === i.variant_id) { v = p.variants[k]; break; } } }
        var cmp = v && v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
        var base = Math.max(cmp, i.original_price);
        sav += Math.max(base - i.final_price, 0) * i.quantity;
        if (cmp <= i.original_price) return;
        document.querySelectorAll('#CartItem-' + (idx + 1) + ', #CartDrawer-Item-' + (idx + 1)).forEach(function (row) {
          var unitTxt = gbp.format(cmp / 100), lineTxt = gbp.format(cmp * i.quantity / 100);
          var det = row.querySelector('.cart-item__details');
          if (det) {
            var unitOld = null;
            det.querySelectorAll('.cart-item__old-price').forEach(function (s) { unitOld = s; });
            if (unitOld) { setOld(unitOld, unitTxt); }
            else {
              var pr = null;
              [].slice.call(det.children).forEach(function (c) { if (!pr && c.classList.contains('product-option') && /^\s*£[\d.,]+\s*$/.test(c.textContent)) pr = c; });
              if (pr) { var s = document.createElement('s'); s.className = 'cart-item__old-price product-option mv-old'; s.textContent = unitTxt; pr.insertAdjacentElement('beforebegin', s); }
            }
          }
          row.querySelectorAll('.cart-item__price-wrapper').forEach(function (w) {
            var lo = w.querySelector('.cart-item__old-price');
            if (lo) { setOld(lo, lineTxt); }
            else { var s2 = document.createElement('s'); s2.className = 'cart-item__old-price price price--end mv-old'; s2.textContent = lineTxt; w.insertAdjacentElement('afterbegin', s2); }
          });
        });
      });
      foots.forEach(function (f) {
        var ex = f.parentElement.querySelector('.mv-sav');
        if (sav <= 0) { if (ex) ex.remove(); return; }
        var txt = '-' + gbp.format(sav / 100);
        if (!ex) {
          ex = document.createElement('div');
          ex.className = 'mv-sav';
          ex.innerHTML = "<span class='mv-sav__l'>Total savings</span><span class='mv-sav__v'></span>";
          f.insertAdjacentElement('beforebegin', ex);
        }
        var vv = ex.querySelector('.mv-sav__v');
        if (vv.textContent !== txt) vv.textContent = txt;
      });
    }).catch(function () {});
  }
  function run() { decorate(); pdp(); cartTrust(); cartSavings(); }
  run();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); }).observe(document.body, { childList: true, subtree: true });
})();
